"use client";

import Popover from "@/components/ui/Popover";

import React from "react";
import styles from "./index.module.css";

const PlpModal = ({
  children,
  modal,
  direction
}: {
  children: React.ReactNode;
  direction: "left" | "right";
  modal: string;
}) => {
  return (
    <Popover modal={modal} direction={direction} className={styles.modal}>
      <div className={styles.modal__content}>{children}</div>
    </Popover>
  );
};

export default PlpModal;
